import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, SectionHead } from "./shared";
import { useI18n } from "../i18n/LanguageContext";

export const FAQ = () => {
  const { t, c } = useI18n();
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="bg-white py-20 sm:py-28" data-testid="faq-section">
      <div className="container-x grid gap-12 lg:grid-cols-[0.8fr_1.2fr]">
        <div>
          <div className="lg:sticky lg:top-28">
            <SectionHead eyebrow={t.faq.eyebrow} title={t.faq.title} sub={t.faq.sub} />
          </div>
        </div>
        <div>
          {c.FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={i} delay={i * 0.04}>
                <div className="border-b border-navy/10" data-testid={`faq-item-${i}`}>
                  <button onClick={() => setOpen(isOpen ? -1 : i)} data-testid={`faq-toggle-${i}`} aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-6 py-6 text-left">
                    <span className={`font-display text-lg font-medium tracking-tight transition-colors duration-300 sm:text-xl ${isOpen ? "text-gold" : "text-navy"}`}>{f.q}</span>
                    <motion.span animate={{ rotate: isOpen ? 135 : 0 }} transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${isOpen ? "bg-gold text-white" : "bg-sand text-navy"}`}>
                      <Plus size={18} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }} className="overflow-hidden">
                        <p className="max-w-2xl pb-6 text-base leading-relaxed text-muted">{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
